import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import { Image } from "react-bootstrap";
import LoadingIndicator from "../../LoadingIndicator";
import YouTube from "react-youtube";
import graphic from "../../../../../Images/graphic.png";
import useUserRole from "../../../../../utils/hooks/useUserRole";
import { UserAssignmentRole } from "../../../../../store/auth/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";

type OwnProps = {
  isPermissionSettingsPresent?: boolean;
  onClick?: () => any;
};

type Props = OwnProps;

const IntroPanel: FunctionComponent<Props> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const permissionSettings = useSelector((state: ApplicationState) => state.auth.userInfo!);
  useEffect(() => {
    setLoading(true);
  }, []);

  const { role, isCoach, isTeacher, isDataManager, isDistrictOwner } = useUserRole();

  // RC-2657 block_access_to_all_data should always be treated as equivalent to "permission settings not present",
  // regardless of isPermissionSettingsPresent.
  const isPermissionRequired = useMemo(
    () => !props.isPermissionSettingsPresent || !!permissionSettings?.block_access_to_all_data,
    [props.isPermissionSettingsPresent, permissionSettings?.block_access_to_all_data]
  );

  const info = useMemo(() => {
    switch (role) {
      case UserAssignmentRole.COACH: {
        {/* RC-2657 setting not present or block access is appeared then show the permission message */}
        let message  = isPermissionRequired
          ? 'You can upload your data. To view your data or data shared by your District Admin, contact your District Admin to set up your access permissions.'
          : <> We provide a spreadsheet interface called the Data Table. <br/>
          You can view data uploaded by District Admin and Coach accounts in the data table.</>;
        return (
          <>
            <p>{message}</p>
          </>
        );
      }
      case UserAssignmentRole.TEACHER: {
        {/* RC-2657 setting not present or block access is appeared then show the permission message */}
        let message  = isPermissionRequired
          ? 'Your District Admin or Coach can share data with you. Contact your District Admin to set up your access permissions so you can view the data.'
          : <> We provide a spreadsheet interface called the Data Table. <br/>
          You can view data uploaded by District Admin and Coach accounts in the data table.</>;
        return (
          <>
            <p>{message}</p>
          </>
        );
      }
      case UserAssignmentRole.SUPERVISOR: {
        let message = <> We provide a spreadsheet interface called the Data Table. <br />
          Wait until teachers and coaches upload data or type in scores.</>;
        return (
          <>
            <p>{message}</p>
          </>
        );
      }
      default:
        return null;
    }
  }, [role]);

  const afterwards = useMemo(() => {
    switch (role) {
      case UserAssignmentRole.COACH:
      case UserAssignmentRole.TEACHER:
        return "Afterwards, you’ll use this table to make grouping decisions.";
      case UserAssignmentRole.SUPERVISOR:
        return (
          <>
            Afterwards, you’ll use this table to review your coaches and
            teachers progress with students.
          </>
        );
      default:
        return null;
    }
  }, [role]);
  return (
    <div className="text-center p-3" data-cy="data-table-intro">
      <div>
        <h2 className="font-weight-bold">
          Coaching with ReadyCoach Begins with Data or Evidence
        </h2>
        <p>{info}</p>
        {/* RC-2657 setting present and block access should not be happen then show the message */}
        {!isTeacher && !isPermissionRequired ? <h3 className="font-weight-bold">{afterwards}</h3> : ''}
      </div>

      {/* <div className="d-flex flex-wrap align-items-center justify-content-around">
        <Image
          src={graphic}
          className="m-x-auto flex-1"
          style={{ maxWidth: "45em" }}
        />
        <div className="flex-1 d-flex align-items-center justify-content-center">
          {loading && <LoadingIndicator />}
          <div style={loading ? { display: "none", height: 0 } : undefined}>
            <YouTube
              onReady={() => setLoading(false)}
              videoId="CqW7DKD3uK0"
              // opts={{ width: "50%" }}
            />
          </div>
        </div>
      </div> */}
      {/* RC-2657 setting present and block access should not be happen then show the button */}
      {(isCoach || isDataManager || isDistrictOwner) && !isPermissionRequired && (
        <button className="blueBtnLg mt-2" onClick={props.onClick} data-cy="start">
          Get Started
        </button>
      )}
    </div>
  );
};

export default IntroPanel;
